import React from "react"
import { ButtonProps } from "@mui/material/Button"
import FormButton from "./FormButton"

export default function FormSecondaryButton({ ...rest }: ButtonProps) {
    return <FormButton {...rest} color="secondary" variant="contained" />
}
